import { configure } from 'vee-validate'

/** App-wide vee-validate defaults: validate on blur, change, input and model update. */
export function initVeeValidate(): void {
  configure({
    validateOnBlur: true,
    validateOnChange: true,
    validateOnInput: true,
    validateOnModelUpdate: true
  })
}
